const FE_Equipment_Card_Types = Object.freeze({
  Member: 1,
  Team: 2,
  Facility: 3,
  Region: 4,
});
export default FE_Equipment_Card_Types;
